export default __webpack_public_path__ + "static/media/youtube.ce2b1ccf.svg";